import { LoadingHavaianas } from 'components'

import * as S from './styles'

export interface LoadingModalProps {
  loadingText?: string
  title?: string
  description?: string
}

export const LoadingModal: React.FC<LoadingModalProps> = ({
  loadingText = 'Carregando...',
  title,
  description,
}) => {
  return (
    <S.ModalWrapper>
      <S.ModalContent>
        <LoadingHavaianas description={description} loadingText={loadingText} title={title} />
      </S.ModalContent>
    </S.ModalWrapper>
  )
}
